import Layout from "app/components/Layout";
import PrivateRoute from "app/components/PrivateRoute";
import { RouteObject } from "react-router-dom";
import DesktopChannelList from "./ChannelList";

export const DesktopChatLayout: RouteObject[] = [
  {
    path: "/chat",
    element: (
      <PrivateRoute>
        <Layout>
        <DesktopChannelList />
        </Layout>
      </PrivateRoute>
    ),
  },
  {
    path: "/chat/:sid/:avatar/:name/:myavatar",
    element: (
      <PrivateRoute>
        <Layout>
        <DesktopChannelList />
        </Layout>
      </PrivateRoute>
    ),
  },

  {
    path: "/chat/:sid",
    element: (
      <PrivateRoute>
        <Layout>
        <DesktopChannelList />
        </Layout>
      </PrivateRoute>
    ),
  },
];